export default "__VITE_ASSET__CYMEXLi2__"